import { gql } from '@apollo/client';

const GET_COUNTRIES = gql`
    query countries {
        countries {
            id
            name
        }
    }
`;

export default GET_COUNTRIES;
